import { Section } from "../../components/components";
import Hero from "../../assets/hero.svg";
import Curve from "../../curve";

const Home = () => {
  return (
    <Curve>
      <div className="home">
        <header className="hero">
          <img src={Hero} alt="hero-img" className="hero-img" />
          <h1 className="hero-heading">
            Hi! I'm Tushar,{" "}
            <span className="primary-color">a passionate developer</span>
          </h1>
        </header>

        <Section />
      </div>
    </Curve>
  );
};

export default Home;
